export const TID = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    services: "nav-services",
    fleet: "nav-fleet",
    partners: "nav-partners",
    contact: "nav-contact",
    reserve: "nav-reserve-btn",
    langSelector: "nav-lang-selector",
    menuMobile: "nav-mobile-toggle",
  },
  calc: {
    origin: "calc-origin",
    destination: "calc-destination",
    swap: "calc-swap-btn",
    when: "calc-datetime",
    service: "calc-service",
    childSeats: "calc-child-seats",
    pet: "calc-pet",
    submit: "calc-submit-btn",
    result: "calc-result",
    ourPrice: "calc-our-price",
    benchmarkTaxi: "calc-bench-taxi",
    benchmarkUber: "calc-bench-uber",
    benchmarkTrain: "calc-bench-train",
    benchmarkOther: "calc-bench-other",
    reserveFromQuote: "calc-reserve-from-quote",
  },
  book: {
    form: "booking-form",
    service: "book-service",
    origin: "book-origin",
    destination: "book-destination",
    datetime: "book-datetime",
    passengers: "book-passengers",
    childSeats: "book-child-seats",
    pet: "book-pet",
    luggage: "book-luggage",
    name: "book-name",
    email: "book-email",
    phone: "book-phone",
    notes: "book-notes",
    submit: "book-submit",
    success: "book-success",
  },
  hero: {
    ctaReserve: "hero-cta-reserve",
    ctaCalc: "hero-cta-calc",
  },
  footer: {
    qr: "footer-qr",
    whatsapp: "footer-whatsapp",
    email: "footer-email",
    lang: "footer-lang",
  },
  whatsappFloat: "whatsapp-float",
};
